<div class="row no-padding responsive">
  <div class="col">
    <img src="assets/sustain.jpg" alt="Locandina della campagna di sostegno a Just Play Bologna">
  </div>
</div>

<div class="row no-padding responsive">
  <div class="col">
    <img src="assets/sustain-no-prices.jpg" alt="Pannello dettagli del sostegno a Just Play Bologna">
  </div>
</div>

<div class="row no-padding">
  <div class="col">
    <p class="lists">
      <b>Consulta qui <a routerLink="/list/A">Lista A</a> e <a routerLink="/list/B">Lista B</a></b>
    </p>
  </div>
</div>

<div class="row no-padding div-custom-link">
  <div class="col">
    <a href="assets/RegolamentoPrestitoGiochi.pdf" class="custom-link" download>Scarica il regolamento del prestito in PDF</a>
  </div>
</div>
